import { useAuthStore } from "../../stores/auth.store";
import { useSeasonStore } from "../../stores/season.store";
import { useUserStore } from "../../stores/user.store";
import { resolveShopAccess, ShopAccess } from "./access";

/**
 * Reads the stores and tells what the current account may do in the shop.
 */
export const useShopAccess = (): ShopAccess => {
  const { authUser } = useAuthStore();
  const { profile } = useUserStore();
  const { currentSeason } = useSeasonStore();

  return resolveShopAccess({
    isAuthenticated: Boolean(authUser),
    members: profile?.members ?? null,
    currentSeason: currentSeason ?? null,
    now: new Date(),
  });
};
